// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBghnWb06s_1HHe-klOIXig0qVM5W-Bc70",
  authDomain: "pinch-point-board.firebaseapp.com",
  projectId: "pinch-point-board",
  storageBucket: "pinch-point-board.firebasestorage.app",
  messagingSenderId: "690092140789",
  appId: "1:690092140789:web:a77a466f628b14a8783dbc",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {
  console.warn("Firebase Messaging not supported in this environment:", e.message);
}
export { messaging };